angular.module('dnecom')
    .directive('dnecomTimezoneSelect', ['_', 'timezones', 'zones', '$timeout', '$http', function(_, timezones, zones, $timeout, $http) {
        return {
            restrict: 'A',
            scope: {
                country: '=',
                ngModel: '='
            },
            link: function(scope, elem, attrs) {
                var $select2;
                scope.timezones = TemplateData.value('timezones');
                scope.$watch(attrs.country, function(country) {
                    if ($select2) {
                        $select2.select2('destroy');
                        $select2.empty();
                    }

                    $select2 = elem.select2({
                        placeholder: 'Select a timezone',
                        allowClear: true,
                        width: 'resolve',
                        data: scope.timezones,
                        templateSelection: function(selection) {
                            return selection.text;
                        },
                        templateResult: function(result) {
                            return result.offset
                                ? $("<strong>" + result.id + "</strong>  <small>" + result.offset + "</small>")
                                : result.text;
                        }
                    });
                    scope.$watch('ngModel', function(newValue, oldValue) {
                        if (!!newValue && newValue === oldValue) {
                            $timeout(function() {
                                $select2.val(newValue).trigger('change');
                            }, 0, false);
                        }
                    });
                });
            }
        };
    }]);
